import { useQuery } from "react-query";
import SearchService from "../api/services/SearchService";

export const useStates = () => {
  return useQuery(["states"], () => SearchService.getStates(), {
    keepPreviousData: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    select({ data }) {
      return data?.groups.map(({ ref_state_code, name }: any) => ({
        value: ref_state_code,
        label: name,
      }));
    },
  });
};
